module.exports = __webpack_public_path__ + "static/media/cross-icon.973e5b74.svg";